<template>
  <div class="permission-required">
    <div class="shaps_bg_animation">
      <img src="../assets/images/icons/404/1.svg" />
      <img src="../assets/images/icons/404/2.svg" />
      <img src="../assets/images/icons/404/3.svg" />
      <img src="../assets/images/icons/404/3.svg" />
      <img src="../assets/images/icons/404/4.svg" />
    </div>
    <div class="container text-center">
      <h2>عذرًا!</h2>
      <i class="fal fa-lock mb-5 mt-3" style="font-size: 8rem; color: #fff"></i>
      <h1 class="mb-5">ليس لديك الصلاحية للدخول</h1>
      <p>عليك العودة إلى الصفحة الرئيسية أو التواصل مع الدعم الفني.</p>

      <router-link
        to="/"
        class="btn btn-primary mt-4 py-3 px-5"
        style="
          border-radius: 50px;
          font-weight: bold;
          background: #fff;
          color: #0897c4 !important;
          border: none;
        "
      >
        العودة للرئيسية <i class="fal fa-home mr-2"></i>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "PermissionRequired",
};
</script>

<style lang="scss" scoped>
.permission-required {
  background-image: linear-gradient(to right, #03cc8f, #0897c4);
  height: 100vh;
  direction: rtl;
  text-align: center;
  @include flexCenterAlignment;
  .container {
    isolation: isolate;
  }
  &::before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    background-image: url(../assets/images/icons/404/5.svg);
    width: 100%;
    height: 100%;
    background-repeat: repeat;
    isolation: auto;
    opacity: 0.5;
  }
  h1 {
    font-size: 4rem;
    color: #fff;
    font-weight: bold;
  }
  h2 {
    font-size: 3rem;
    color: #fff;
  }
  p {
    color: rgba(255, 255, 255, 0.9);
    font-size: 1.2rem;
  }
  .shaps_bg_animation {
    position: absolute;
    width: 100%;
    height: 100%;
    img {
      position: absolute;
      &:nth-child(1) {
        left: 5%;
        top: 10%;
      }
      &:nth-child(2) {
        right: 5%;
        top: 10%;
      }
      &:nth-child(3) {
        left: 20%;
        top: 20%;
      }
      &:nth-child(4) {
        right: 20%;
        top: 20%;
        animation: rotateAnimation 2s infinite;
      }
      &:nth-child(5) {
        left: 30%;
        top: 30%;
        animation: rotateAnimation 2s infinite;
      }
    }
  }
}
@keyframes rotateAnimation {
  0% {
    transform: translateY(-10px);
  }
  50% {
    transform: translateY(0px);
  }
  100% {
    transform: translateY(-10px);
  }
}
</style>
